import React, {Component} from 'react';
import classnames from 'classnames';
import {SortContainer} from './style';
import {assetTargetSort} from '../../../utils/status';
import {objDeepCopy} from '../../../utils/tool';

class SortItem extends Component {
  constructor(props) {
    super(props);
    const {SortItem} = this.props.store;
    if (SortItem) {
      this.state = SortItem;
    } else {
      this.state = {
        items: objDeepCopy(assetTargetSort),
      }
    }
  }

  componentDidMount() {
  }

  handleClick = (item) => {
    const {items} = this.state;
    let curItem = {};
    items.forEach((value, index) => {
      value.selected = false;
      if (index === item.index) {
        value.selected = true;
        curItem = value;
      }
    })
    this.setState({
      items,
    })

    const {saveCurrData, addCondition} = this.props.store;
    const {closeFilter, defaultIndex, changeCurrFilterItems} = this.props;
    // 暂存数据
    saveCurrData('SortItem', this.state);
    // 增加选择条件
    addCondition(curItem.condition, true);
    closeFilter()
    let filterItems = [
      {name: '默认排序', sort: -1, index: 8},
      {name: '开始时间', sort: 1, index: 0},
      {name: '开始时间', sort: 0, index: 3},
      {name: '结束时间', sort: 1, index: 2},
      {name: '结束时间', sort: 0, index: 9},
     ];
    changeCurrFilterItems(defaultIndex, filterItems[item.index]);
  }

  render() {
    const {items} = this.state;
    return (
      <SortContainer>
        <ul>
          {items.map(
            (item, index) => (
              <li
                key={item.name}
                className={classnames([{'actived': item.selected}])}
                onClick={() => {
                  this.handleClick({
                    index,
                    name: item.name,
                    id: item.param,
                  })
                }}
              >{item.name}</li>
            )
          )}
        </ul>
      </SortContainer>
    );
  }
}

export default SortItem;
